import { Plug, Sparkles } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { TECH_LOGOS, TECH_EXTRA } from "../../data/site";

const EXTRA_ICONS = { Plug, Sparkles };

export default function Tech() {
    return (
        <section data-testid="tech-section" className="relative border-t border-slate-200 bg-gradient-to-b from-white to-blue-50/70 py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
                <Reveal className="flex flex-wrap items-end justify-between gap-6">
                    <div>
                        <Eyebrow testId="tech-eyebrow">Technology</Eyebrow>
                        <h2 className="font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
                            Built with modern technology.
                        </h2>
                    </div>
                    <p className="max-w-md text-sm leading-relaxed text-slate-500 sm:text-base">
                        Tools are chosen per problem — the outcome leads, the stack follows.
                    </p>
                </Reveal>

                <div className="mt-16 grid grid-cols-2 gap-4 sm:grid-cols-4 lg:gap-5">
                    {TECH_LOGOS.map((t, i) => (
                        <Reveal key={t.slug} delay={i * 0.05}>
                            <div
                                data-testid={`tech-logo-${t.slug}`}
                                className="group flex h-full flex-col items-center justify-center gap-4 rounded-2xl border border-slate-200 bg-white px-4 py-8 shadow-card transition-[transform,border-color,box-shadow] duration-500 hover:-translate-y-1 hover:border-brand/40 hover:shadow-hover"
                            >
                                <img
                                    src={`https://cdn.simpleicons.org/${t.slug}`}
                                    alt={`${t.name} logo`}
                                    loading="lazy"
                                    className="h-10 w-10 transition-transform duration-500 group-hover:scale-110"
                                />
                                <span className="font-mono text-xs font-semibold uppercase tracking-[0.18em] text-slate-500 transition-colors duration-300 group-hover:text-slate-900">
                                    {t.name}
                                </span>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2 lg:gap-6">
                    {TECH_EXTRA.map((cat, i) => {
                        const Icon = EXTRA_ICONS[cat.icon];
                        return (
                            <Reveal key={cat.label} delay={i * 0.08}>
                                <div
                                    data-testid={`tech-card-${cat.label.toLowerCase()}`}
                                    className="group h-full rounded-2xl border border-slate-200 bg-white p-7 shadow-card transition-[border-color,box-shadow] duration-500 hover:border-brand/40 hover:shadow-hover"
                                >
                                    <div className="flex items-center gap-3">
                                        <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-subtle text-brand">
                                            <Icon className="h-5 w-5" strokeWidth={1.8} />
                                        </div>
                                        <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.25em] text-brand">
                                            {cat.label}
                                        </p>
                                    </div>
                                    <ul className="mt-5 grid grid-cols-1 gap-x-6 sm:grid-cols-2">
                                        {cat.items.map((item) => (
                                            <li
                                                key={item}
                                                className="border-b border-slate-100 py-2.5 text-sm text-slate-600 transition-colors duration-300 group-hover:text-slate-900"
                                            >
                                                {item}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
